import { useGetMeQuery } from 'store/services/user/meApi';

export const useIsElite = (skip: boolean = false) => {
  const { data: user } = useGetMeQuery(undefined, { skip });

  // UI display only - actual subscription validation is enforced server-side
  const isElite = user?.isElite || false;
  const eliteSince = user?.eliteSince || null;

  return { isElite, eliteSince, user };
};
